/**
 * import node_modules
 */
import 'desvg';
import objectFitImages from 'object-fit-images';
import picturefill from 'picturefill';
import SmoothScroll from 'smooth-scroll';

/**
 * import modules
 */
import Sample from './modules/sample';
import Common from './modules/common';
import Modal from './modules/modal';
import Accordion from './modules/accordion';
import SelectorForm from './modules/selectorForm';
import TopCanvas from './modules/topCanvas';
import J_SpTab from './modules/j_sptab';
import Ipad from './modules/ipad';

// header、footerのインクルードとheaderのリンク制御
import HeaderFooterInc from './modules/header_footer_inc';

import SlickSlider from './modules/slickSlider';
import SwiperSlider from './modules/swiperSlider';

/**
 * Mainクラス
 * @constructor
 */
class Main {
  constructor() {
    this.setup();
  }
  /**
   * インスタンス生成時に実行する処理
   */
  setup() {
    document.addEventListener('DOMContentLoaded', () => {
      this.created();

    })
    window.addEventListener('load', () => {
      this.mounted();
    });
  }
  /**
   * ページ読み込み時に実行する処理
   */
  created() {
    picturefill();

    const sample = new Sample();
    sample.init();

    const common = new Common();
    common.init();

    const slickSlider = new SlickSlider();
    slickSlider.init();

    const swiperSlider = new SwiperSlider();
    swiperSlider.init();

    const modal = new Modal();
    modal.init();

    const accordion = new Accordion();
    accordion.init();

    const selectorForm = new SelectorForm();
    selectorForm.init();

    const j_SpTab = new J_SpTab();
    j_SpTab.init();

    const ipad = new Ipad();
    ipad.init();

    const headerFooterInc = new HeaderFooterInc();
    headerFooterInc.init();

    const topCanvas = new TopCanvas();
    topCanvas.init();

    // -----------------------------------------
    // cookie
    // -----------------------------------------

    // document.cookie = "greeting=hello";

    const DOC = document;
    const body = DOC.body;
    const bodyClass = body.className;
    // alert(bodyClass);

    $.cookie = function () {

      const cookies = DOC.cookie;
      const cookiesArray = cookies.split(';');
      const $page = $('#page');
      const m = 36720000;
      const box = 'box-cookie-01';
      let text01,
          text02,
          text03;
      if (bodyClass == 'th') {
        text01 = 'เว็บไซต์นี้ของบริษัทฯ ใช้ระบบ Cookie ดังนั้นหากต้องการใช้บริการจากเว็บไซต์นี้ จำเป็นต้องยินยอมการใช้งาน Cookie ของบริษัทฯ ก่อน ';
        text02 = 'รายละเอียดที่นี่';
        text03 = 'ยินยอม';
      } else if (bodyClass == 'zh') {
        text01 = '本公司在服务中使用Cookie。利用本公司的服务，即表示用户已同意使用Cookie。';
        text02 = '详见这里';
        text03 = '同意';
      } else if (bodyClass == 'vi') {
        text01 = 'Dịch vụ của công ty chúng tôi có sử dụng Cookie. Khi quý khách sử dụng dịch vụ của công ty chúng tôi, chúng tôi sẽ xem là quý khách đã đồng ý với việc sử dụng Cookie của công ty chúng tôi. ';
        text02 = 'Chi tiết ở đây';
        text03 = 'Đồng ý';
      } else {
        text01 = 'Cookies help us deliver our services. By using our services, you agree to our use of cookies. ';
        text02 = 'Learn more';
        text03 = 'OK';
      }

      const html = '<div id="' + box + '">' +
                  '<p class="t-rignt btn-close">' + 
                  '<button type="button" id="cookie-close-01">' + 
                  '<span>' +
                  'close' +
                  '</span>' +
                  '</button>' +
                  '</p>' +
                  '<div class="box-inner">' +
                  '<div class="area-01">' +
                  '<p>' +
                  text01 +
                  '<a href="https://www.asahi-kasei.com/cookie/" target="_blank">' +
                  text02 +
                  '</a>' +
                  '</p>' +
                  '</div>' +
                  '<button type="button" id="cookie-btn-01">' + 
                  '<span>' +
                  text03 +
                  '</span>' +
                  '</button>' +
                  '</div>' +
                  '</div>';
      let count = 0;
  
      function add () {
          if ($page.find('#' + box).length === 0) {
              $page.append(html);
              setTimeout(function () {
                  $('#' + box).css('bottom', '0');
              }, 100);
          }
      }
      cookiesArray.forEach(function (i, j) {
          const array = i.split('=');
  
          if (array[0].trim(' ') === 'cookieData') {
              count = 1;
          }
      });
  
      if (count === 0) {
          add();
      }
  
      $('#' + box).find('#cookie-btn-01').on('click', function () {
          DOC.cookie = 'cookieData=true; path=/; max-age=' + m;
          $('#' + box).css('bottom', '-100%');
      });
      $('#' + box).find('#cookie-close-01').on('click', function () {
          $('#' + box).css('bottom', '-100%');
      });
    };
    $(function () {
      $.cookie();
    })

  }
  /**
   * 画像読み込み後に実行する処理
   */
  mounted() {

    this.init_deSVG('.js-desvg');

    this.init_objectFitImages('.object-fit');

    this.init_smoothScroll();
  }



  /**
   * ライブラリ/deSVG
   * インラインsvgをsvgタグに変換
   * https://github.com/benhowdle89/deSVG
   * @param {Element} target ターゲットとなる要素
   */
  init_deSVG(target) {
    deSVG(target, true)
  }

  /**
   * ライブラリ/object-fit-images
   * css object-fit のポリフィル
   * https://github.com/fregante/object-fit-images
   * @param {Element} target ターゲットとなる要素
   */
  init_objectFitImages(target) {
    objectFitImages(target);
  }

  /**
   * ライブラリ/picturefill
   * html pictureタグのポリフィル
   * https://scottjehl.github.io/picturefill/
   */
  init_picturefill() {
    picturefill();
  }

  /**
   * ライブラリ/smooth-scroll
   * スムーススクロール
   * https://github.com/cferdinandi/smooth-scroll
   */
  init_smoothScroll() {
    /**
     * ターゲットとなる要素
     * @type {Element}
     */
    const targetElement = 'a[href*="#"]';

    /**
     * オプション
     * @type {object}
     */
    const option = {
      speed: 1000,
      easing: 'easeInOutCubic',
      speedAsDuration: true,
      //header: '.l-header' 固定ヘッダーの場合
    }

    new SmoothScroll(targetElement, option);
  }
}

export default new Main();
